import { useState } from "react";

import type { useSupabaseLoader } from "../../../server/supabase/hooks";

/** A loader's state, where the data may be left over from the last load while it loads again. */
export interface KeptState<T> {
  data: T | null;
  loading: boolean;
  error: Error | null;
  reload: () => void;
}

/**
 * A loader's state with its last data kept through a reload, so a count doesn't drop to its
 * placeholder and back. Not through a failure, which shows as one.
 */
export function useKeptWhileReloading<T>(
  state: ReturnType<typeof useSupabaseLoader<T>>,
): KeptState<T> {
  const [kept, setKept] = useState<T | null>(null);
  if (state.data !== null && state.data !== kept) setKept(state.data);

  return state.error || state.data !== null ? state : { ...state, data: kept };
}
